<template>
  <div class="countdown">
    <div class="float-start number-wrap" v-for="(n, i) in formattedMinutes" :key="i">
      <transition-group :name="animated ? 'slide-down' : ''">
        <template v-for="x in 10">
          <span class="number" v-if="`${x-1}` === n" :key="x-1">{{ n }}</span>
        </template>
      </transition-group>
    </div>
    <div class="float-start number-wrap separator">
      <span class="number">:</span>
    </div>
    <div class="float-start number-wrap" v-for="(n, i) in formattedSeconds" :key="i">
      <transition-group :name="animated ? 'slide-down' : ''">
        <template v-for="x in 10">
          <span class="number" v-if="`${x-1}` === n" :key="x-1">{{ n }}</span>
        </template>
      </transition-group>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
  time: {
    type: Number,
    required: true,
  },
  animated: Boolean,
  color: {
    type: String,
    default: '#97CB2A',
  },
  fontSize: {
    type: String,
    default: '80px',
  },
});

const emit = defineEmits(['done']);

// eslint-disable-next-line vue/no-setup-props-destructure
const timeLeft = ref(props.time);

const minutes = computed(() => Math.floor(timeLeft.value / 60));
const seconds = computed(() => Math.floor(timeLeft.value % 60));

const formattedMinutes = computed(() => padNumber(minutes.value));
const formattedSeconds = computed(() => padNumber(seconds.value));

function padNumber (number) {
  return number.toString().padStart(2, '0');
}

let worker = null;

onMounted(() => {
  worker = new Worker('/workers/countDown.js');
  worker.postMessage({
    event: 'start',
    time: props.time,
  });
  worker.addEventListener('message', (e) => {
    if (e.data === 'done') {
      emit('done');
    } else if (e.data.event === 'update') {
      timeLeft.value = e.data.timeLeft;
    }
  });
});

onBeforeUnmount(() => {
  if (worker) {
    worker.postMessage('stop');
    worker.terminate();
  }
});
</script>

<style scoped>
.countdown {
  width: 100%;
  height: calc(v-bind(fontSize) / 0.66);
  display: flex;
  justify-content: center;
  color: v-bind(color);
  font-size: v-bind(fontSize);
  font-weight: bold;
}

.number-wrap {
  position: relative;
  width: calc(v-bind(fontSize) / 1.33);
  height: calc(v-bind(fontSize) / 0.66);
}

.number-wrap.separator {
  width: calc(v-bind(fontSize) / 2);
}

.number {
  position: absolute;
  top: 0;
  left: 0;
  text-shadow: 3px 3px 2px black;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.8s ease-out;
}

.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-60px);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateY(60px);
}
</style>
